import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=39071f02&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"
import style0 from "./DataList.vue?vue&type=style&index=0&id=39071f02&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39071f02",
  null
  
)

export default component.exports